import React from "react";
import PropTypes from "prop-types";

import "./PlayerBadge.scss";

const PlayerBadge = ({ firstName, lastName, color, fontSize, badgeSize }) => (
  <div className="player-badge" 
    style={{ 
      backgroundColor: color, 
      fontSize, 
      height: `${badgeSize}px`, 
      width: `${badgeSize}px` 
    }}>
    {`${(firstName && firstName.charAt(0)) || ""}${(lastName &&
      lastName.charAt(0)) ||
      ""}`}
  </div>
);

PlayerBadge.propTypes = {
  badgeSize: PropTypes.number, 
  color: PropTypes.string,
  firstName: PropTypes.string,
  fontSize: PropTypes.string,
  lastName: PropTypes.string
};

PlayerBadge.defaultProps = {
  badgeSize: null,
  color: "",
  firstName: "",
  fontSize:"",
  lastName: ""
};

export default PlayerBadge;
